module.exports = __webpack_public_path__ + "img/albero-natale.c6763bd9.png";